import httpClientPayments from '../api/httpClientPayments';

export const getAllMeetingMeals = async ({
  pageNumber = 1,
  pageSize = 20,
  status = null,
  searchTerm = null,
} = {}) => {
  const params = { pageNumber, pageSize };
  if (status !== null && status !== undefined && status !== '') {
    params.status = status;
  }
  if (searchTerm !== null && searchTerm !== undefined && searchTerm.trim() !== '') {
    params.searchTerm = searchTerm.trim();
  }
  const response = await httpClientPayments.get('/api/payments/MeetingMealManagement/GetAll', { params });
  return response.data;
};

export const getMeetingMealById = async (id) => {
  const response = await httpClientPayments.get(`/api/payments/MeetingMealManagement/GetById/${id}`);
  return response.data;
};

export const getMeetingMealsByPeriod = async (period, { status = null, pageNumber = 1, pageSize = 20 } = {}) => {
  const params = { pageNumber, pageSize };
  if (status !== null && status !== undefined && status !== '') {
    params.status = status;
  }
  const response = await httpClientPayments.get(
    `/api/payments/MeetingMealManagement/GetByPeriod/Period/${period}`,
    { params },
  );
  return response.data;
};

export const getMeetingMealsByMemberId = async (memberId) => {
  const response = await httpClientPayments.get(
    `/api/payments/MeetingMealManagement/GetByMemberId/Member/${memberId}`,
  );
  return response.data;
};

export const createMemberMeal = async (payload) => {
  const response = await httpClientPayments.post('/api/payments/MeetingMealManagement/CreateMemberMeal', payload);
  return response.data;
};

export const previewBulkCreateMeals = async (payload) => {
  const response = await httpClientPayments.post('/api/payments/MeetingMealManagement/PreviewBulkCreateMeals', payload);
  return response.data;
};

export const startBulkCreateMeals = async (payload) => {
  const response = await httpClientPayments.post('/api/payments/MeetingMealManagement/StartBulkCreateMeals', payload);
  return response.data;
};

export const getBulkCreateMealsStatus = async (jobId) => {
  const response = await httpClientPayments.get(`/api/payments/MeetingMealManagement/BulkCreateStatus/${jobId}`);
  return response.data;
};

export const cancelMeetingMeal = async (payload) => {
  const response = await httpClientPayments.post('/api/payments/MeetingMealManagement/Cancel/Cancel', payload);
  return response.data;
};

export const listSkippedAutomaticMealDebts = async (params = {}) => {
  const response = await httpClientPayments.get(
    '/api/payments/MeetingMealManagement/ListSkippedAutomaticMealDebts',
    { params },
  );
  return response.data;
};

export const exportSkippedAutomaticMealDebtsCsv = async (params = {}) => {
  const response = await httpClientPayments.get(
    '/api/payments/MeetingMealManagement/ExportSkippedAutomaticMealDebtsCsv',
    { params, responseType: 'blob' },
  );
  return response.data;
};

export default {
  getAllMeetingMeals,
  getMeetingMealById,
  getMeetingMealsByPeriod,
  getMeetingMealsByMemberId,
  createMemberMeal,
  previewBulkCreateMeals,
  startBulkCreateMeals,
  getBulkCreateMealsStatus,
  cancelMeetingMeal,
  listSkippedAutomaticMealDebts,
  exportSkippedAutomaticMealDebtsCsv,
};
